import type { Prototype } from "../prototype-types";

export const amyTalusPrototypes: Prototype[] = [
  {
    id: "insider-side-cart",
    name: "Insider Side Cart",
    path: "/at/insider-side-cart",
    description:
      "Side cart that keeps browsing context while previewing Insider value (savings + perks). Includes two variants: auto-open overlay drawer and a persistent mini-rail.",
    owner: "Amy",
    createdAt: "2025-12-18",
    lastUpdated: "2026-01-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/473ff7b27b321b4694e10a65c5a2083ff588263e8b2fbb95af366e7d0d945f82.png",
    creationTool: "cursor",
  },
  {
    id: "prototype-starter",
    name: "Prototype Starter Page",
    path: "/at/prototype-starter",
    description:
      "Starter sandbox for building new prototypes. Includes a couple scaffolds (idea draft + preview, stepper) and the VariantSwitcher by default.",
    owner: "Amy",
    createdAt: "2025-12-18",
    lastUpdated: "2026-01-08",
    surfaceArea: "Other",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cbcc306af1d6d4581d516e10107d7583e6ee2dfcd7ec848b948d99501262b451.png",
    creationTool: "cursor",
  },
];
